import { mutationOptions } from '@tanstack/react-query';

import { mockGymFinderService } from 'app/features/leads/services/gym-finder';
import type { UpdateLeadStatusParams } from 'app/features/leads/services/gym-finder/types';

export const updateLeadStatusMutationOptions = () =>
  mutationOptions({
    mutationFn: ({ id, status }: UpdateLeadStatusParams) => mockGymFinderService.updateLeadStatus(id, status),
  });
